import React from 'react';
import { connect } from "react-redux";
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';

export class PosProstor extends React.Component{
    state={
        pickedBusinessPremises: {},
        formatedPosBroj: ""
    }


    submitHandler = async event => {
                
    }

    changedProstor = async (data) => {
        await this.props.businesssPremises.filter(premises => premises.label === data.label).map(filteredData => (
            this.setState({
                pickedBusinessPremises: filteredData
            })
        ))
    }

    render(){
        let listOption = []
        this.props.businesssPremises.map((data) => (
           listOption.push({label: data.label, value: data.premises_name})
        ))

        return (
            <div style={{padding: "40px"}}>
                <div className="form-group row">
                    <label htmlFor="listPosProstor" className="col-sm-4 col-form-label">Odaberi poslovni prostor</label>
                    <div className="col-sm-4">
                        <Dropdown 
                            options={listOption} 
                            onChange={this.changedProstor} 
                            value={this.state.pickedBusinessPremises.label ? this.state.pickedBusinessPremises.label: ""} 
                            placeholder="Izaberi" 
                        />
                    </div> 
                    
                </div>
                
                <br/>
               
                <form>
                <div className="form-group row">
                    <label htmlFor="NazPosProst" className="col-sm-4 col-form-label">Naziv Poslovnog Prostora</label>
                    <div className="col-sm-4">
                        <input
                                disabled
                                type="text"
                                value={this.state.pickedBusinessPremises.description ? this.state.pickedBusinessPremises.description: ""}
                            />
                    </div>
                </div>
                 
                <div className="form-group row">
                    <label htmlFor="oznPosProst" className="col-sm-4 col-form-label">Oznaka Poslovnog Prostora</label>
                    <div className="col-sm-4">
                        <input   
                            disabled                      
                            type="text"
                            value={this.state.pickedBusinessPremises.label ? this.state.pickedBusinessPremises.label: ""}                           
                        />
                    </div>
                </div>
                <div className="form-group row">
                    <label htmlFor="Adresa" className="col-sm-4 col-form-label">Adresa</label>
                    <div className="col-sm-4">
                        <input  
                            disabled                       
                            type="text"
                            value={this.state.pickedBusinessPremises.address ? this.state.pickedBusinessPremises.address : ""}                            
                        />
                    </div>
                </div>
                <div className="form-group row" style={{ alignItems: 'center' }}>
                    <label htmlFor="E-commerce" className="col-sm-4 col-form-label">E-commerce</label>
                    <div className="col-sm-4">
                        <label className="form-check-label" htmlFor="ecommerce">
                            <input  
                                disabled                       
                                type="checkbox"
                                checked={this.state.pickedBusinessPremises.ecommerce}
                            />
                            &nbsp;&nbsp; e-commerce
                        </label>
                    </div>
                </div>   
                {/*}
                <div className="form-group row justify-content-md-center">
                    <div className="col-sm-2">
                        <button 
                            disabled
                            className="btn btn-info" 
                            style={{padding:"10px"}}
                            onClick={e => e.preventDefault()}
                        > Save </button>
                    </div>
                </div>
                */}
                
            </form>
               
            </div>
        )
    }

}


const mapStateToProps = state => {
    return {
        businesssPremises : state.client.businesssPremises
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(PosProstor);


